import { API } from '../api';

const getById = (id) => {
    return API.get('client/resource/resource/get', { id: id })
        .then((response) => {
            if (API.isSuccess(response)) {
                return response.data;
            }

            throw new Error('error');
        });
};

const getByGroup = (groupId = null) => {
    return API.get('client/resource/resource/get-by-group', { groupId: groupId })
        .then((response) => {
            if (API.isSuccess(response)) {
                return response.data;
            }

            return [];
        });
};

const sort = (data) => {
    return API.post('client/resource/resource/sort', { data: data })
        .then(response => {
            if (API.isSuccess(response)) {
                return true;
            }

            return false;
        });
}

export const ApiResourceService = {
    getById,
    getByGroup,
    sort
};